import React from 'react'
import styled from 'styled-components'
import LazyLoad from 'react-lazyload'
import Image from 'next/image'
import { createResource, useResource } from '@/lib/i18n'
import Link from 'next/link'
import { Action } from '@@/action_pb'
import { eventLogProducer } from '@/lib/event-logger'
import { SocialShareEnum } from '@/lib/enums/language'

const resource = createResource({
  en: {
    oneTitle: 'Licensed and Supervised',
    secondTitle: 'Our Office Address',
    threeTitle: 'Follow us',
    secondAddress: ' Headquarters',
    secondDetail:
      'Pasaraya Blok M, Building B, 1st Floor, Unit B1 Jl. Iskandarsyah Raya No. 2, Melawai, Kby. Baru, Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12160',
    threeDesc1: '2025 PT Kredit Pintar Indonesia. All rights reserved. Please find',
    threeDesc2: 'Terms and Conditions',
    threeDesc3: 'and',
    threeDesc4: 'Privacy Policy',
    threeDesc5: 'regarding Kredit Pintar’s service.',
    threeDesc6: 'Please kindly read',
    contentTitle1: 'ATTENTION:',
    contentTitle2: 'DISCLAIMER:',
    contentTitle3: 'Attention',
    contentTitle4: 'Disclaimer',
    collectTit: 'Operation Office',
    collectContent:
      'Kirana Three Office Tower lt 7, Jl. Kirana Avenue No.2, Kelapa Gading Timur, Kecamatan Kelapa Gading, Jakarta Utara, Daerah Khusus Ibukota Jakarta 14240',
    customerServiceTitle: 'Customer Service Operational Office',
    customerServiceaddressFirst: 'Mandiri InHealth Tower Lt. 3',
    customerServiceAddress:
      'Jl. Prof. DR. Satrio Kav. E-IV No.6, Kuningan, Karet Kuningan, Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12940',
    threeDesc7: 'Read',
    contentTitle5: 'Ringkasan Informasi Produk dan Layanan (RIPLAY) Umum',
  },
  id: {
    oneTitle: 'Izin dan Pengawasan',
    secondTitle: 'Alamat Kantor Kami',
    threeTitle: 'Ikuti Kami',
    secondAddress: ' Kantor Pusat',
    secondDetail:
      'Pasaraya Blok M, Building B, 1st Floor, Unit B1 Jl. Iskandarsyah Raya No. 2, Melawai, Kby. Baru, Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12160',
    threeDesc1: '2025 PT Kredit Pintar Indonesia. Seluruh hak cipta. Tolong temukan',
    threeDesc2: 'Syarat dan ketentuan',
    threeDesc3: 'dan',
    threeDesc4: 'Kebijakan pribadi',
    threeDesc5: 'tentang layanan Kredit Pintar.',
    threeDesc6: 'Silakan membaca',
    contentTitle1: 'PERHATIAN:',
    contentTitle2: 'DISCLAIMER:',
    contentTitle3: 'Perhatian',
    contentTitle4: 'Disclaimer',
    collectTit: 'Kantor Operasional',
    collectContent:
      'Kirana Three Office Tower lt 7, Jl. Kirana Avenue No.2, Kelapa Gading Timur, Kecamatan Kelapa Gading, Jakarta Utara, Daerah Khusus Ibukota Jakarta 14240',
    customerServiceTitle: 'Kantor Operasional Layanan Pelanggan',
    customerServiceaddressFirst: 'Mandiri InHealth Tower Lt. 3',
    customerServiceAddress:
      'Jl. Prof. DR. Satrio Kav. E-IV No.6, Kuningan, Karet Kuningan, Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12940',
    threeDesc7: 'Baca',
    contentTitle5: 'Ringkasan Informasi Produk dan Layanan (RIPLAY) Umum',
  },
})

const Footer = () => {
  const { t } = useResource(resource)

  const sendEventByType = (
    type:
      | 'SITEMAPLINKCLICK'
      | 'TANDCLINKCLICK'
      | 'PRIVACYPOLICYLINKCLICK'
      | 'ATTENTIONLINKCLICK'
      | 'DISCLAIMERLINKCLICK',
  ) => {
    eventLogProducer.push({
      action: Action[type],
    })
  }

  const eventClick = (item) => {
    eventLogProducer.push({
      action: Action.FOLLOWUSBUTTONCLICK,
      extra: {
        optionName: item,
      },
    })
  }

  return (
    <FooterStyle>
      <div className="container">
        <div className="one">
          <div className="left">
            <div className="title" dangerouslySetInnerHTML={{ __html: t('oneTitle') }}></div>
            <div className="brands">
              <LazyLoad>
                <div>
                  <Image
                    className="logo"
                    width={118}
                    height={32}
                    quality={85}
                    src={'/images/home/ojk-logo-new-25.png'}
                    alt="ojk"
                    placeholder="empty"
                  />
                </div>
                <div>
                  <Image
                    className="logo"
                    width={118}
                    height={48}
                    quality={85}
                    src={'/images/home/afpi-new.png'}
                    alt="afpi"
                    placeholder="empty"
                  />
                </div>
                <div>
                  <Image
                    className="kominfo"
                    width={48}
                    height={48}
                    quality={85}
                    placeholder="empty"
                    src={'/images/home/top-brand.png'}
                    alt="kominfo"
                  />
                </div>
                <div>
                  <Image
                    className="bsi"
                    width={95}
                    height={48}
                    quality={85}
                    placeholder="empty"
                    src={'/images/home/bsi-iso.png'}
                    alt="bsi"
                  />
                </div>
                <div>
                  <Image
                    className="laps-sjk"
                    width={118}
                    height={48}
                    quality={85}
                    placeholder="empty"
                    src={'/images/home/laps-sjk-logo.png'}
                    alt="laps sjk"
                  />
                </div>
              </LazyLoad>
            </div>
            <Link href="/sitemap">
              <a className="title sitemap" onClick={() => sendEventByType('SITEMAPLINKCLICK')}>
                <div dangerouslySetInnerHTML={{ __html: 'Sitemap' }}></div>
              </a>
            </Link>
          </div>
          <div className="middle">
            <div className="title" dangerouslySetInnerHTML={{ __html: t('secondTitle') }}></div>
            <section className="subtitle">
              <LazyLoad>
                <section className="sub-hook">
                  <Link replace={false} href="https://maps.app.goo.gl/RReNQWzfMk5jwwLc7">
                    <a target="_blank">
                      <Image
                        width={16}
                        height={16}
                        quality={85}
                        placeholder="empty"
                        className="title-icon"
                        src={'/images/home/address.png'}
                        alt="address"
                      />
                    </a>
                  </Link>
                  <span> {t('secondAddress')}</span>
                </section>
                <section>{t('secondDetail')}</section>
                <section className="sub-hook">
                  <Link replace={false} href="https://maps.app.goo.gl/Do4bkKdf5w7HtTHF8">
                    <a target="_blank">
                      <Image
                        width={16}
                        height={16}
                        quality={85}
                        placeholder="empty"
                        className="title-icon"
                        src={'/images/home/address.png'}
                        alt="address"
                      />
                    </a>
                  </Link>
                  <span> {t('customerServiceTitle')}</span>
                </section>
                <section>
                  <div>{t('customerServiceaddressFirst')}</div>
                  <div>{t('customerServiceAddress')}</div>
                </section>

                <section className="sub-hook">
                  <Link replace={false} href="https://goo.gl/maps/7AjZkaMNBFXUZ3r1A">
                    <a target="_blank">
                      <Image
                        width={16}
                        height={16}
                        quality={85}
                        placeholder="empty"
                        className="title-icon"
                        src={'/images/home/address.png'}
                        alt="address"
                      />
                    </a>
                  </Link>
                  <span> {t('collectTit')}</span>
                </section>
                <section>{t('collectContent')}</section>
                <section className="sub-hook">
                  <Image
                    width={16}
                    height={16}
                    quality={85}
                    placeholder="empty"
                    className="title-icon"
                    src={'/images/home/mobile.png'}
                    alt="mobile"
                  />
                  <span> (021) 50598882</span>
                </section>
                <section className="sub-hook">
                  <Image
                    width={16}
                    height={16}
                    quality={85}
                    placeholder="empty"
                    className="title-icon"
                    src={'/images/home/mail.png'}
                    alt="email"
                  />
                  <span> cs@kreditpintar.com</span>
                </section>
              </LazyLoad>
            </section>
          </div>
          <div className="right">
            <div className="title">{t('threeTitle')}</div>
            <div className="subtitle">
              <div className="right-wrap">
                <LazyLoad>
                  <a
                    onClick={() => {
                      eventClick(SocialShareEnum.FACEBOOK)
                    }}
                    href="https://www.facebook.com/KreditPintarOfficial/"
                    rel="noopener noreferrer nofollow"
                    target="_blank"
                    className="right-hook"
                  >
                    <Image
                      width={42}
                      height={40}
                      quality={85}
                      placeholder="empty"
                      className="right-icon"
                      src={'/images/home/facebook.png'}
                      alt="facebook"
                    />
                  </a>
                  <a
                    onClick={() => {
                      eventClick(SocialShareEnum.TWITTER)
                    }}
                    href="https://twitter.com/kreditpintar"
                    rel="noopener noreferrer nofollow"
                    target="_blank"
                    className="right-hook"
                  >
                    <Image
                      width={42}
                      height={40}
                      quality={85}
                      placeholder="empty"
                      className="right-icon"
                      src={'/images/home/twitter.png'}
                      alt="twitter"
                    />
                  </a>
                  <a
                    onClick={() => {
                      eventClick(SocialShareEnum.INSTAGRAM)
                    }}
                    href="https://www.instagram.com/kreditpintar/"
                    rel="noopener noreferrer nofollow"
                    target="_blank"
                    className="right-hook"
                  >
                    <Image
                      width={42}
                      height={40}
                      quality={85}
                      placeholder="empty"
                      className="right-icon"
                      src={'/images/home/photo.png'}
                      alt="instagram"
                    />
                  </a>
                </LazyLoad>
              </div>
              <div className="right-text">
                <span>© {t('threeDesc1')} </span>
                <a href={'/terms-of-service'} className="privacy" onClick={() => sendEventByType('TANDCLINKCLICK')}>
                  {t('threeDesc2')}
                </a>{' '}
                {t('threeDesc3')}
                <a
                  href={'/privacy-policy'}
                  className="privacy"
                  onClick={() => sendEventByType('PRIVACYPOLICYLINKCLICK')}
                >
                  {' '}
                  {t('threeDesc4')}
                </a>
                <span> {t('threeDesc5')} </span>
              </div>
              <div className="right-bottom">
                <img className="notice" src={'/images/home/footer-icon.png'} alt="notice" />
                {t('threeDesc6')}{' '}
                <Link href="/attention">
                  <a
                    title={t('contentTitle3')}
                    className="attention"
                    onClick={() => sendEventByType('ATTENTIONLINKCLICK')}
                  >
                    <span dangerouslySetInnerHTML={{ __html: t('contentTitle3') }}></span>
                  </a>
                </Link>{' '}
                {t('threeDesc3')}{' '}
                <Link href="/disclaimer">
                  <a
                    title={t('contentTitle4')}
                    className="attention"
                    onClick={() => sendEventByType('DISCLAIMERLINKCLICK')}
                  >
                    <span dangerouslySetInnerHTML={{ __html: t('contentTitle4') }}></span>
                  </a>
                </Link>
              </div>
              <div className="right-bottom">
                <img className="notice" src={'/images/home/footer-icon.png'} alt="notice" />
                {t('threeDesc7')}{' '}
                <Link href="/riplay">
                  <a
                    title={t('contentTitle5')}
                    className="attention"
                  >
                    <span dangerouslySetInnerHTML={{ __html: t('contentTitle5') }}></span>
                  </a>
                </Link>{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </FooterStyle>
  )
}

export default Footer

const FooterStyle = styled.div`
  width: 100%;
  min-height: 30vh;
  margin-bottom: 50px;
  .sitemap {
    display: inline-block;
    padding-top: 30px;
    text-decoration: underline;
  }
  .title {
    font-size: 18px;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: #212121;
    line-height: 21px;
    margin: 48px 0 32px;
  }
  .subtitle {
    font-size: 16px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #757575;
    line-height: 19px;
    .sub-hook {
      display: flex;
      align-items: center;
    }
  }
  .title-icon {
    width: 16px;
    margin-right: 5px;
  }
  .kominfo {
    margin-bottom: 12px;
    width: 50px;
    height: 50px;
  }
  .bsi {
    display: block;
  }
  .laps-sjk {
    display: block;
  }
  @media only screen and (max-width: 1000px) {
    .container {
      margin: 0 auto;
      padding: 16px;
      .content {
        display: block !important;
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #757575;
        line-height: 24px;
        div {
          width: 100% !important;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    .container {
      max-width: 1140px;
      margin: 0 auto;
      padding: 82px 0;
    }
  }

  .one {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .left {
      width: 250px;
      .brands {
        height: 200px;
        .logo {
          margin-bottom: 12px;
        }
      }
    }
    .middle {
      width: 350px;
      .subtitle {
        section {
          padding-bottom: 24px;
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #757575;
          line-height: 19px;
        }
      }
    }
    .right {
      width: 348px;
      .right-wrap {
        display: inline-block;
        margin-bottom: 62px;
        .right-hook {
          padding-right: 6px;
          .right-icon {
            width: 42px;
            height: 40px;
          }
        }
      }
      .right-text {
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #757575;
        line-height: 20px;
        .privacy {
          text-decoration: underline;
          color: red;
        }
      }
      .right-bottom {
        padding-top: 24px;
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #757575;
        line-height: 20px;
        .notice {
          width: 16px;
          height: 16px;
          margin-right: 5px;
          margin-bottom: 4px;
          vertical-align: middle;
        }
        a {
          color: #1cc812;
          text-decoration: underline;
        }
      }
    }
  }
`
